/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/


// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyVoidFunc = (...args: any[]) => void;

/**
 * Wrapper around setInterval() but additionally calls unref() on created interval.
 */
export function setIntervalUnref<T extends AnyVoidFunc>(callback: T, ms: number, ...cbArgs: Parameters<T>): NodeJS.Timeout {
	return setInterval(callback, ms, ...cbArgs).unref();
}

/**
 * Wrapper around setTimeout() but additionally calls unref() on created interval.
 */
export function setTimeoutUnref<T extends AnyVoidFunc>(callback: T, ms: number, ...cbArgs: Parameters<T>): NodeJS.Timeout {
	return setTimeout(callback, ms, ...cbArgs).unref();
}
